<script>
import BaseCard from "./BaseCard";

export default {
  name: "MainPropertiesCard",
  extends: BaseCard,
  props: ["acc"],
  data: function() {
    return {
      header: "Algemene eigenschappen",
      disabled: !this.hasPermission("update accommodatie"),
      values: {
        beheerder: this.acc.beheerder,
        eigendom: this.acc.eigendom,
        bouwjaar: this.acc.bouwjaar,
        opheffingsjaar: this.acc.opheffingsjaar,
        oppervlakte: this.acc.oppervlakte
      }
    };
  },
  computed: {
    schema: function() {
      return [
        {
          type: "text",
          name: "bouwjaar",
          label: "Bouwjaar",
          placeholder: "Onbekend",
          disabled: this.disabled,
          validation: "optional|date:YYYY|max:2100|min:1800",
          "validation-messages": {
            date: "Bouwjaar moet een jaar zijn",
            min: "Bouwjaar moet later dan 1800 zijn",
            max: "Bouwjaar moet eerder dan 2100 zijn"
          },
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          type: "text",
          name: "opheffingsjaar",
          label: "Opheffingsjaar",
          placeholder: "",
          disabled: this.disabled,
          validation: "optional|date:YYYY|max:2100|min:1800",
          "validation-messages": {
            date: "Opheffingsjaar moet een jaar zijn",
            min: "Opheffingsjaar moet later dan 1800 zijn",
            max: "Opheffingsjaar moet eerder dan 2100 zijn"
          },
          "input-class": this.disabled ? "disabled" : "editMode"
        },
        {
          component: "hr",
          class: "mx-8 my-4"
        },
        {
          type: "text",
          name: "oppervlakte",
          label: "Oppervlakte in m2",
          placeholder: "Onbekend",
          disabled: this.disabled,
          validation: "number",
          "validation-messages": {
            number: "Oppervlakte moet een getal zijn"
          },
          "input-class": this.disabled ? "disabled" : "editMode"
        },

        {
          type: "submit",
          "input-class": ["btn", "btn-blue", this.disabled ? "disabled" : ""],
          label: "Opslaan"
        }
      ];
    }
  },
  methods: {
    submitHandler: async function(data) {
      const updatedAccommodatie = {
        bouwjaar: parseInt(data.bouwjaar),
        opheffingsjaar: parseInt(data.opheffingsjaar),
        oppervlakte: parseInt(data.oppervlakte),
        beheerder: data.beheerder,
        eigendom: data.eigendom
      };
      const [ok, msg] = await this.$store.dispatch(
        "updateAccommodatie",
        updatedAccommodatie
      );
      this.parseResponse(ok, msg);
    }
  }
};
</script>
